// tslint:disable
// @ts-nocheck
/**
 * Enter API Documentation
 * ## Interactive Documentation ##### Our API documentation allows you to test API calls straight from this website. ##### To do this, scroll down a little and click the green \"Authorize\" button (with a padlock) to the right and below. A pop-up should appear. ##### In the popup, enter your \"client_id\" and \"client_secret\" values (these will be provided to you) and press \"Authorize\". You should now be logged in (you can open up your network tab to see the API traffic going through). ##### From here, you can click any endpoint below to expand its details and click the \"Try it out\" button that appears in the expanded section. ##### Fill out the parameter fields and then click \"Execute\" to call the endpoint. The results of your query should be shown below. ## Authentication ##### Our API uses the OAuth 2.0 Client Credentials flow to authorize clients. ##### With your provided \"Client Id\" and \"Client Secret\", make the following call: ``` POST /oauth/token HTTP/1.1 Host: api.enter.health  grant_type=client_credentials &client_id=XXXXXXXXXXXX &client_secret=YYYYYYYYYYY ``` ##### Here\'s an example CURL request: ``` curl \'https://api.enter.health/oauth/token\' -H \'accept: application/json\' --data \'grant_type=client_credentials&client_id=XXXXXXXXXXXX&client_secret=YYYYYYYYYYY\' ``` ##### The response should look something like this ``` {   \"access_token\" : \"AAAAAAAAAAAAAAAAAAA\",   \"refresh_token\" : \"BBBBBBBBBBBBBBBBBBB\" }  ``` ##### With the access token provided, you can make an authenticated call to any of the endpoints below by including the header \"Authorization: Bearer AAAAAAAAAAAAAAAAAAA\" with your API request. ##### Here\'s an example of a basic curl request to the \"/me\" endpoint ``` curl \'https://api.enter.health/me\' -H \'accept: application/json\' -H \'authorization: Bearer AAAAAAAAAAAAAAAAAAA\' ``` ##### Note that access tokens are not long-living tokens. The lifetime of them differs from client to client, but they may last as short as 15 minutes (if you would like an increase in time, please reach out to us). ### Comparators ##### Filter parameters need to be formatted with a comparator and value in the format of \"COMPARATOR:VALUE\". The following is a list of possible values:  ##### GTE - Greater than or equal ##### GT - Greater than ##### LT - Less Than ##### LTE - Less than or equal ##### EQ - Equal ##### NQ - Not Equal ##### LK - Like ##### NLK - Not Like ##### EMPTY - Is null ##### NEMPTY - Is not null ## Subject to Change ##### Note that this API is in active development and may be subject to changes at any time. ##### This document is a living document with current specifications. If your integration does not seem to work properly, please refer back to this page to look for updates. ##### If you are still having issues, please reach out to support. 
 *
 * The version of the OpenAPI document: 2
 * Contact: support@enter.health
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ObjectNoResponse,
    SupportCreateManualEstimatePayload,
    SupportEstimate,
    SupportEstimateSortType,
    SupportGenerateEstimatePayload,
    SupportCreateManualEstimatePayloadToJSON,
    SupportGenerateEstimatePayloadToJSON,
    ObjectNoResponseFromJSON,
    SupportEstimateFromJSON,
} from '../models';

export interface CreateManualEstimateClaimRequest {
    supportCreateManualEstimatePayload: SupportCreateManualEstimatePayload;
}

export interface DisableSupportEstimateRequest {
    id: string;
}

export interface GenerateEstimateClaimRequest {
    supportGenerateEstimatePayload: SupportGenerateEstimatePayload;
}

export interface GetSupportEstimateRequest {
    id: string;
}

export interface ListSupportEstimatesRequest {
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListSupportEstimatesOrderEnum>;
    filterCreated?: Array<string>;
    filterProfessionalId?: Array<string>;
    filterInstitutionalId?: Array<string>;
    filterDentalId?: Array<string>;
    filterNynf3Id?: Array<string>;
    filterEligibilityId?: Array<string>;
    filterClaimId?: Array<string>;
    sort?: Array<SupportEstimateSortType>;
}

/**
 * no description
 */
export class EstimateApi extends runtime.BaseAPI {

    /**
     * Manually estimate a claim
     * Manual estimate a claim
     */
    async createManualEstimateClaimRaw(requestParameters: CreateManualEstimateClaimRequest): Promise<runtime.ApiResponse<SupportEstimate>> {
        if (requestParameters['supportCreateManualEstimatePayload'] === null || requestParameters['supportCreateManualEstimatePayload'] === undefined) {
            throw new runtime.RequiredError('supportCreateManualEstimatePayload','Required parameter requestParameters.supportCreateManualEstimatePayload was null or undefined when calling createManualEstimateClaim.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:estimate", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/estimate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportCreateManualEstimatePayloadToJSON(requestParameters['supportCreateManualEstimatePayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportEstimateFromJSON(jsonValue));
    }

    /**
     * Manually estimate a claim
     * Manual estimate a claim
     */
    async createManualEstimateClaim(requestParameters: CreateManualEstimateClaimRequest): Promise<SupportEstimate> {
        const response = await this.createManualEstimateClaimRaw(requestParameters);
        return await response.value();
    }

    /**
     * Disable an estimate
     * Disable an estimate
     */
    async disableSupportEstimateRaw(requestParameters: DisableSupportEstimateRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling disableSupportEstimate.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["delete:estimate", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/estimate/{id}/disable`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Disable an estimate
     * Disable an estimate
     */
    async disableSupportEstimate(requestParameters: DisableSupportEstimateRequest): Promise<ObjectNoResponse> {
        const response = await this.disableSupportEstimateRaw(requestParameters);
        return await response.value();
    }

    /**
     * Estimate a claim
     * Estimate a claim
     */
    async generateEstimateClaimRaw(requestParameters: GenerateEstimateClaimRequest): Promise<runtime.ApiResponse<SupportEstimate>> {
        if (requestParameters['supportGenerateEstimatePayload'] === null || requestParameters['supportGenerateEstimatePayload'] === undefined) {
            throw new runtime.RequiredError('supportGenerateEstimatePayload','Required parameter requestParameters.supportGenerateEstimatePayload was null or undefined when calling generateEstimateClaim.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:estimate", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/estimate/generate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportGenerateEstimatePayloadToJSON(requestParameters['supportGenerateEstimatePayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportEstimateFromJSON(jsonValue));
    }

    /**
     * Estimate a claim
     * Estimate a claim
     */
    async generateEstimateClaim(requestParameters: GenerateEstimateClaimRequest): Promise<SupportEstimate> {
        const response = await this.generateEstimateClaimRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets an estimate
     * Get an estimate
     */
    async getSupportEstimateRaw(requestParameters: GetSupportEstimateRequest): Promise<runtime.ApiResponse<SupportEstimate>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getSupportEstimate.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:estimate", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/estimate/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportEstimateFromJSON(jsonValue));
    }

    /**
     * Gets an estimate
     * Get an estimate
     */
    async getSupportEstimate(requestParameters: GetSupportEstimateRequest): Promise<SupportEstimate> {
        const response = await this.getSupportEstimateRaw(requestParameters);
        return await response.value();
    }

    /**
     * List a claim estimate
     * List claim estimates
     */
    async listSupportEstimatesRaw(requestParameters: ListSupportEstimatesRequest): Promise<runtime.ApiResponse<Array<SupportEstimate>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.filterProfessionalId) {
            queryParameters['filterProfessionalId'] = requestParameters.filterProfessionalId;
        }

        if (requestParameters.filterInstitutionalId) {
            queryParameters['filterInstitutionalId'] = requestParameters.filterInstitutionalId;
        }

        if (requestParameters.filterDentalId) {
            queryParameters['filterDentalId'] = requestParameters.filterDentalId;
        }

        if (requestParameters.filterNynf3Id) {
            queryParameters['filterNynf3Id'] = requestParameters.filterNynf3Id;
        }

        if (requestParameters.filterEligibilityId) {
            queryParameters['filterEligibilityId'] = requestParameters.filterEligibilityId;
        }

        if (requestParameters.filterClaimId) {
            queryParameters['filterClaimId'] = requestParameters.filterClaimId;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:estimate", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/estimate`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SupportEstimateFromJSON));
    }

    /**
     * List a claim estimate
     * List claim estimates
     */
    async listSupportEstimates(requestParameters: ListSupportEstimatesRequest): Promise<Array<SupportEstimate>> {
        const response = await this.listSupportEstimatesRaw(requestParameters);
        return await response.value();
    }

}

/**
    * @export
    * @enum {string}
    */
export enum ListSupportEstimatesOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
